import {createSlice} from "@reduxjs/toolkit";
import {getPurchaseDetails} from "../actions/purchase";

export enum TypeOfAction {
  purchased = "purchased",
  used = "used",
  refunded = "refunded"
}

export interface IPurchaseHistoryItem {
  date: string
  points: number
  amount?: number
  type: TypeOfAction
}

export interface IPurchaseHistory {
  presentAvailablePointsAmount: number | null,
  purchaseHistory: IPurchaseHistoryItem[],
  loading: boolean,
}

const initialState: IPurchaseHistory = {
  presentAvailablePointsAmount: null,
  purchaseHistory: [],
  loading: false,
}

export const purchaseHistorySlice = createSlice({
  name: "profileSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getPurchaseDetails.rejected, (state, action) => {
      state.loading = false;
    })
    builder.addCase(getPurchaseDetails.fulfilled, (state, action) => {
      state.purchaseHistory = action.payload.purchaseHistory
      state.presentAvailablePointsAmount = action.payload.presentAvailablePointsAmount
      state.loading = false;
    })
    builder.addCase(getPurchaseDetails.pending, (state, action) => {
      state.loading = true;
    })
  }
})

export default purchaseHistorySlice.reducer